<template>
  <div class="bg-white">
    <div class="layout-wrapper">
      <!--      <header-bar/>-->
      <OldVersionBanner v-if="!app.switchCRM && app.verified" />
      <OldVersionDialog v-if="!app.switchCRM && app.verified" />
      <div
        v-if="!app.switchCRM"
        class="d-lg-flex">
        <ExpiredBanner v-if="showExpiredBanner" />
        <TermAcceptPopup v-if="showTermAccept" />
        <nav-menu v-if="!app.loginV2" />
        <router-view v-if="renderComponent && app.verified" />
        <!--        <router-view />-->
        <ShopExpiresPopup
          v-if="accountExpireds.length > 0"
          :accounts="accountExpireds" />
        <!--        <SuggestTagPopup v-if="suggestTag" />-->
        <!--        <AccountPaymentPopup v-if="app.zaloNotify" />-->
        <!--               <CloudBanner v-if="this.showCloudBanner && renderComponent" />-->
        <!-- <BannerFlex  v-if="renderComponent" bannerLink="banner_banking.svg" />
               <new-banner v-if="this.showNewBanner && renderComponent" /> -->
        <!-- <BannerAI /> -->
      </div>
      <div v-if="app.switchCRM">
        <h2
          style="height: 100vh !important"
          class="text-danger d-flex justify-content-center"
          v-if="errorCRM">
          Bạn không có quyền truy cập SaleworkZalo!
        </h2>
        <div v-else>
          <router-view />
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
</style>
<script>
import Config from "./lib/Config";
import ShopExpiresPopup from "./components/ShopExpiresPopup";
import ExpiredBanner from "./components/ExpiredBanner";
import OldVersionBanner from "./components/common/OldVersionBanner.vue";
import OldVersionDialog from "./components/Popup/OldVersionDialog.vue";
import TermAcceptPopup from "./components/Popup/TermAcceptPopup";
import { getTokenExpiration } from "./lib/Common";
import { initAISDK } from "./lib/AI";
// import BannerAI from "./components/AI/BannerAI.vue";
// import CloudBanner from "@/components/Popup/CloudBanner";
// import BannerFlex from "@/components/Popup/BannerFlex";
// import NewBanner from "@/components/Popup/NewBanner";
// import AccountPaymentPopup from "./components/AccoxuntPaymentPopup";

export default {
  name: "App",
  data() {
    return {
      errorCRM: false,
      accountExpireds: [],
      renderComponent: true,
      userPlan: "",
      showPopDeleteShop: false,
      suggestTag: false,
      zaloNotify: false,
      showExpiredBanner: false,
      showTermAccept: false,
      showTour: true,
      showCloudBanner: true,
      showNewBanner: false,
      isTabActive: true,
      originalTitle: document.title,
      processing: false
    };
  },
  components: {
    // NewBanner,
    // CloudBanner,
    TermAcceptPopup,
    ExpiredBanner,
    OldVersionBanner,
    OldVersionDialog,
    // AccountPaymentPopup,
    ShopExpiresPopup,
    // BannerFlex,
    // BannerAI,
    NavMenu: () => import("./components/NavMenu")
    // HeaderBar: () => import("./components/Header")
  },

  methods: {
    getConnectionAI() {
      initAISDK();
    },
    forceRerender() {
      // Remove my-component from the DOM
      this.renderComponent = false;

      this.$nextTick(() => {
        // Add the component back in
        this.renderComponent = true;
      });
    },
    verifyToken(reverify = false) {
      let config = {};
      if (Config.DEV) {
        config = {
          headers: {
            "evn-token": "aEdib2EzeDkzdyUyRjRLREdFUnQzbGtnJTNEJTNEOlJIM2FkOW1NZXJoWWFIOU1IRWg3S3clM0QlM0Q"
          }
        };
      }

      this.$http
        .get("/api/auth/verify", config)
        .then((response) => {
          if (reverify) {
            this.updateToken(response);
          } else {
            this.fetchDataLocal(response);
          }
        })
        .catch(() => {
          if (this.app.switchCRM) {
            this.errorCRM = true;
            return;
          }
          window.location = "https://salework.net/login?target=zalo";
        });
    },
    fetchAllAccounts() {
      return this.$http.get("/api/account/getAll").then((resp) => {
        return (this.accounts = resp.data);
      });
    },
    fetchCustomerCode() {
      return this.$http.get("/api/v2/customer/getCode").then((resp) => {
        this.app.customerCodeList = resp.data;
      });
    },
    updateToken(response) {
      let data = response.data;
      localStorage.setItem("userToken", data.accessToken);
      localStorage.setItem("userTokenExpTime", getTokenExpiration(data.accessToken));
    },
    fetchDataLocal(response) {
      this.verified = true;
      this.app.shopExpired = false;
      this.app.restDay = 0;
      let data = response.data;
      this.app.paymentType = data.paymentType;
      this.checkShopExpired();

      // if (!localStorage.getItem("showTour")) {
      this.showTour = false;
      // }
      if (data.accessToken != null) {
        localStorage.setItem("userToken", data.accessToken);
        localStorage.setItem("userTokenExpTime", getTokenExpiration(data.accessToken));
        localStorage.setItem("loginV2Token", data.loginV2Token);
        localStorage.setItem("cToken", data.ctoken);

        this.app.user = data.user;
        this.originalTitle = this.originalTitle + " (" + this.app.user.companyCode + ")";
        document.title = this.originalTitle;
        this.app.sessionId = data.sessionId;
        if (data.user.termAccept == 0 || data.user.termAccept == -1) {
          this.showTermAccept = true;
        } else if (!this.app.shopExpired) {
          this.app.permissions = JSON.parse(data.permissions);
          this.app.shopLimit = data.shopLimit;
          this.app.staffLimit = data.staffLimit;
          this.app.verified = true;
          this.userPlan = data.user.plan;
          this.app.showAllContact = data.showAllContact;
          this.app.showPhoneInContact = data.showPhoneInContact;
          this.app.showListFriend = data.showListFriend;
          this.app.manageTags = data.manageTags;
          this.app.manageAccounts = data.manageAccounts;
          this.app.showAIDashboard = data.showAIDashboard;

          if (!this.isUserTypeAdmin()) {
            if (data.tagAssignMe != null) {
              this.app.tagAssignMe = JSON.parse(data.tagAssignMe);
            }
            if (data.tagAssign != null) {
              this.app.tagAssign = JSON.parse(data.tagAssign);
            }
          }
          if (!localStorage.getItem("CloudBanner")) {
            if (this.isUserTypeAdmin()) {
              this.showCloudBanner = true;
            }
          }
          if (!localStorage.getItem("banner14052024")) {
            this.showNewBanner = true;
          }
          this.fetchAllQuickReply();
          this.forceRerender();
          // this.fetchAllAccounts().then((accounts) => {
          //   this.app.accounts = accounts.filter((s) => s.status === "ACTIVE");
          //   this.accountExpireds = accounts.filter((s) => s.status === "OFF");
          // });
          this.fetchAccountList().then((accounts) => {
            this.accountExpireds = accounts.filter((s) => s.status === "OFF");
          });
          this.getAllGroupId();
          this.getAllCharacterFilter();
          this.getAccountSetting();
          this.getDraftMessage();
          this.fetchCustomerCode();
          this.getAlias();
          setInterval(() => {
            if (this.app.hasQuota) {
              const message = this.app.messageQueue.shift();
              if (message) {
                this.downloadMessageImage(message);
              }
            } else {
              this.app.messageQueue = [];
            }
          }, 100);
          this.startPendingMessageCron();
        }
        // if (["esbt", "sota"].includes(this.app.user.companyCode)) {
        //   this.getConnectionAI();
        // }
      } else {
        this.showExpiredBanner = true;
      }
    },
    startPendingMessageCron() {

      const pageSize = 1;

      if (!this.app.emptyAccountIds) {
        this.app.emptyAccountIds = new Set();
      }

      if (!this.app.loadingPendingMessages) {
        this.app.loadingPendingMessages = false;
      }

      setInterval(async () => {
        if (this.app.loadingPendingMessages) {
          return;
        }
        // queue còn dữ liệu thì chưa lấy thêm
        if (this.app.messageQueue.length > 0) {
          return;
        }
        const accounts = this.app.accounts || [];
        if (accounts.length === 0) {
          return;
        }
        this.app.loadingPendingMessages = true;
        try {
          for (const account of accounts) {
            const accountId = account.accountId;
            // account này hết dữ liệu rồi
            if (this.app.emptyAccountIds.has(accountId)) {
              continue;
            }
            let items = [];
            try {
              const resp = await this.$http.get("/api/cloud/findByAccountId", { params: { accountId: accountId } });
              items = resp.data || [];
            } catch (_) {
              items = [];
            }
            // ít hơn pageSize => hết dữ liệu
            if (items.length < pageSize) {
              this.app.emptyAccountIds.add(accountId);
            }
            for (const item of items) {
              try {
                const message = JSON.parse(item.data);
                this.app.messageQueue.push(message);
              } catch (_) {
                // ignore
              }
            }
            // có dữ liệu thì dừng
            if (items.length > 0) {
              break;
            }
          }
        } catch (e) {
          console.error(e);
        } finally {
          this.app.loadingPendingMessages = false;
        }
      }, 3777);
    },

    getImageUrl(message) {
      let url = null;
      if (message.msgType === "chat.photo") {
        try {
          const data = JSON.parse(message.content);
          url = data.href;
          try {
            const params = JSON.parse(data.params || "{}");
            if (params.hd) {
              url = params.hd;
            }
          } catch (_) {
            // ignore
          }
        } catch (e) {
          // ignore
        }
      }
      return url;
    },
    cleanMessage(message) {
      return JSON.parse(JSON.stringify({
        id: message.id,
        msgType: message.msgType,
        ts: message.ts,
        status: message.status,
        content: message.content,
        mentions: message.mentions,
        actionId: message.actionId,
        cliMsgId: message.cliMsgId,
        createAt: message.createAt,
        dname: message.dname
      }));
    },
    async downloadImageBlob(imageUrl) {
      return new Promise((resolve, reject) => {
        const img = new Image();

        img.crossOrigin = "anonymous";

        img.onload = () => {
          const canvas = document.createElement("canvas");
          canvas.width = img.naturalWidth;
          canvas.height = img.naturalHeight;

          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0);

          canvas.toBlob((blob) => {
            if (blob) {
              resolve(blob);
            } else {
              reject(new Error("Canvas toBlob failed"));
            }
          }, "image/jpeg");
        };

        img.onerror = () => {
          reject(new Error("Image load failed"));
        };

        img.src = imageUrl;
      });
    },
    isMessageTooOld(message) {
      const ts = Number(message.ts);

      if (!ts) {
        return true;
      }

      const messageTime = new Date(ts);
      const now = new Date();

      const diffMs = now.getTime() - messageTime.getTime();
      const diffDays = diffMs / (1000 * 60 * 60 * 24);

      return diffDays > 20;
    },
    blobToBytes(blob) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
          const arrayBuffer = reader.result;
          const bytes = Array.from(new Uint8Array(arrayBuffer));
          resolve(bytes);
        };
        reader.onerror = reject;
        reader.readAsArrayBuffer(blob);
      });
    },
    async downloadMessageImage(message) {
      let imageUrl = this.getImageUrl(message);
      if (this.isMessageTooOld(message)) {
        return;
      }
      if (!(await this.canUploadImage(message))) {
        return;
      }
      if (this.processing) {
        return;
      }
      // đã tải rồi
      if (this.app.downloadedMessageIds.has(message.id.msgId)) {
        return;
      }
      this.app.downloadedMessageIds.add(message.id.msgId);
      if (await this.isUploaded(message)) {
        return;
      }
      this.processing = true;
      try {
        if (imageUrl) {

          const blob = await this.downloadImageBlob(imageUrl);
          const bytes = await this.blobToBytes(blob);
          const originalFilename = imageUrl.split("/").pop().split("?")[0];
          await fetch("/api/hub/saveImageByClient", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              bytes: bytes,
              originalFilename: originalFilename,
              mediaType: blob.type || "image/jpeg",
              message: this.cleanMessage(message),
              originalUrl: imageUrl
            })
          });

        }
      } catch (e) {
        console.error(e);
      } finally {
        this.processing = false;
      }
    },
    async isUploaded(message) {
      const resp = await this.$http.get(
        "/api/hub/getReplaceUrl",
        {
          params: {
            conversationId: message.id.conversationId,
            msgId: message.id.msgId
          }
        }
      );
      const replaceUrl = resp.data;
      return !!replaceUrl?.code;
    },
    async canUploadImage(message) {
      const conversationId = message.id.conversationId;
      if (!conversationId) {
        return false;
      }
      const accountId = conversationId.split("_")[0];
      // cache
      let cached =
        this.app.cloudSettingCache.find(
          o => o.accountId === accountId
        );
      let cloudData = cached?.data;

      // chưa có cache
      if (!cloudData) {
        try {
          const resp = await this.$http.get("/api/hub/cloudSubscription", {
            params: {
              accountId: accountId,
              companyCode: this.app.user.companyCode
            }
          });

          cloudData = resp.data;
        } catch (e) {
          cloudData = {
            hasQuota: false,
            cloudSetting: {
              active: false
            },
            error: true
          };
        }
        this.app.cloudSettingCache.push({
          accountId: accountId, data: cloudData
        });
      }
      // quota
      if (!cloudData?.hasQuota) {
        this.app.hasQuota = false;
        return false;
      }
      const setting = cloudData.cloudSetting;
      // active
      if (!setting?.active) {
        return false;
      }
      const conSplit = conversationId.split("_");
      // không xử lý page
      if (conSplit[3] !== "0") {
        return false;
      }
      // default dữ liệu cũ
      const conversationType = setting.conversationType || "all";
      const contentType = setting.contentType || "all";
      // 0 = personal
      // 1 = group
      const isGroup = conSplit[2];
      // personal only
      if (conversationType === "personal" && isGroup === "1") {
        return false;
      }
      // group only
      if (conversationType === "group" && isGroup === "0") {
        return false;
      }
      // chỉ xử lý ảnh
      if (contentType !== "all" && contentType !== "image") {
        return false;
      }
      return message.msgType === "chat.photo";
    },
    handleVisibilityChange() {
      this.isTabActive = !document.hidden;
      if (this.isTabActive) {
        this.clearTitleNotification();
      }
    },
    handleNewMessage() {
      if (!this.isTabActive) {
        this.setTitleNotification();
      }
    },
    setTitleNotification() {
      if (!document.title.startsWith("(1) ")) {
        document.title = `(1) ${this.originalTitle}`;
      }
    },
    clearTitleNotification() {
      document.title = this.originalTitle;
    }
  },
  created() {
    if (window.location.pathname == "/loginZaloV2") {
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      this.app.cToken = urlParams.get("cToken");
      this.app.loginV2 = true;
      this.app.verified = true;
    } else {
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      const conversationId = urlParams.get("id");
      if (conversationId) {
        this.app.switchCRM = true;
        this.app.conversationIdForCRM = conversationId;
      }

      if (!this.app.verified) {
        this.verifyToken();
      }
    }

    document.addEventListener("Reverify", () => {
      this.verifyToken(true);
    });
  },
  mounted() {
    this.originalTitle = document.title;
    document.addEventListener("visibilitychange", this.handleVisibilityChange);
    this.$bus.$on("updateTitleNewMessage", this.handleNewMessage);
  },
  beforeDestroy() {
    document.removeEventListener("Reverify");
    document.removeEventListener("visibilitychange", this.handleVisibilityChange);
  }
};
</script>

<style>
@import "style/css/magnific-popup.css";
@import "style/css/owl.carousel.min.css";
@import "style/css/owl.theme.default.min.css";
@import "style/css/bootstrap-dark.min.css";
@import "style/css/bootstrap.min.css";
@import "style/css/app-dark.min.css";
@import "style/css/app.min.css";
@import "style/scss/icon.css";
</style>
